
/**
 * 集采管理
 * @author lixian
 */
export default {
  BASE_URL: '',
  api: [
    {
      name: 'query',
      desc: '集采需求查询',
      method: 'GET',
      path: 'om/cenPurchase/query'
    },
    {
      name: 'getCenPurDetail',
      desc: '集采需求单详情',
      method: 'GET',
      path: 'om/cenPurchase/getCenPurDetail'
    },
    {
      name: 'initCenPurPayments',
      desc: '结算方式加载',
      method: 'GET',
      path: 'paramConfig/bizPaymentResource/initCenPurPayments'
    },
    {
      name: 'getCatasByParentId',
      desc: '商品类目接口',
      method: 'GET',
      path: 'category/getCatasByParentId'
    },
    {
      name: 'auditNum',
      desc: '获取审核标签的数量',
      method: 'GET',
      path: 'om/cenPurchase/auditNum'
    },
    {
      name: 'auditReason',
      desc: '需求单审核不通过原因',
      method: 'GET',
      path: 'om/cenPurchase/auditReason'
    },
    {
      name: 'audit',
      desc: '审核需求单',
      method: 'POST',
      path: 'om/cenPurchase/audit'
    },
    {
      name: 'getAllCatas',
      method: 'GET',
      desc: '集采分类初始化', // 集采分类-初始化
      path: 'category/getAllCatas'
    },
    {
      name: 'getCategoryCount',
      method: 'GET',
      desc: '集采需求单数量统计', // 获取需求单数量，需求单管理tree
      path: 'category/purManage/category'
    },
    {
      name: 'getCollectDetail',
      method: 'GET',
      desc: '集采需求单详情', // 获取需求单详情，需求单管理表格的数据
      path: 'om/cenPurchase/manage/query'
    },
    {
      name: 'getCollectDetailOption',
      method: 'GET',
      desc: '集采需求单状态选项', // 获取需求单状态选项，用于搜索框下拉列表
      path: 'om/cenPurchase/status/option'
    },
    {
      name: 'saveCenPurCatas',
      method: 'POST',
      desc: '保存分类', // 集采分类-保存
      path: 'om/cenPurchase/saveCenPurCatas'
    },
    {
      name: 'getCenPurCatas',
      method: 'GET',
      desc: '获取保存的分类ID', // 集采分类-回显参数
      path: 'category/getCenPurCatas'
    },
    {
      name: 'getCatasCondtion',
      desc: '获取完整的二级分类',
      method: 'GET',
      path: 'om/cenPurchase/getCatasCondtion'
    },
    {
      name: 'checkCataRemove',
      desc: '检测分类是否可以移除',
      method: 'GET',
      path: 'om/cenPurchase/checkRemove'
    },
    {
      name: 'getCenCateStatus',
      desc: '活动页面是否隐藏无商品分类 -获取数据',
      method: 'GET',
      path: 'om/cenPurchase/getCenCateStatus'
    },
    {
      name: 'changeCenCateStatus',
      desc: '业务设置-- 活动页面是否隐藏无商品分类 - 更改状态',
      method: 'POST',
      path: 'om/cenPurchase/changeCenCateStatus'
    },
    /**
     * 活动管理
     */
    {
      name: 'statisticsActs',
      desc: '状态统计',
      method: 'GET',
      path: 'om/cenPurActivity/statisticsActs'
    },
    {
      name: 'saveOrPusAct',
      desc: '保存/发布',
      method: 'POST',
      path: 'om/cenPurActivity/saveOrPusAct'
    },
    {
      name: 'selectActivities',
      desc: '活动列表',
      method: 'POST',
      path: 'om/cenPurActivity/selectActivities'
    },
    {
      name: 'getActivitiyDetail',
      desc: '获取集采活动详情',
      method: 'POST',
      path: 'om/cenPurActivity/getActivitiyDetail'
    },
    {
      name: 'getAllCenPurs',
      desc: '需求单详情列表',
      method: 'GET',
      path: 'om/cenPurActivity/getAllCenPurs'
    },
    {
      name: 'getPurchasersInfo',
      desc: '企业详情列表',
      method: 'GET',
      path: 'om/cenPurActivity/getPurchasersInfo'
    },
    {
      name: 'cancelActivity',
      desc: '取消活动',
      method: 'POST',
      path: 'om/cenPurActivity/cancelActivity',
      append: true
    },
    {
      name: 'deleteActivity',
      desc: '删除活动',
      method: 'POST',
      path: '/om/cenPurActivity/deleteActivity',
      append: true
    },
    {
      name: 'finishActivity',
      desc: '完成活动',
      method: 'POST',
      path: 'om/cenPurActivity/finishActivity',
      append: true
    },
    {
      name: 'getSupsByCatas',
      desc: '获取供应商',
      method: 'GET',
      path: 'sob/supportOrgManage/getSupsByCatas'
    },
    {
      name: 'getStosBySupIdAndCataId',
      desc: '获取供应商仓库',
      method: 'GET',
      path: 'sob/supportOrgManage/getStosBySupIdAndCataId'
    },
    {
      name: 'getCatasByParentId',
      desc: '获取商品类目',
      method: 'GET',
      path: '/category/getCatasByParentId'
    },
    {
      name: 'needStatistics',
      desc: '统计各状态下的需求单数量',
      method: 'GET',
      path: '/om/cenPurchase/status/statistics'
    },
    {
      name: 'graphStatistics',
      desc: '需求单统计下的图表数据',
      method: 'GET',
      path: '/om/cenPurchase/category/statistics'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/cen-purchase/index.js